import React, {useState, useRef, useEffect} from "react";
import { GOOGLE_FONTS } from "../config/fonts";
import { HexColorPicker } from "react-colorful";

const SettingsPanel = ({ fontSettings, setFontSettings }) => {
  
  const [customFonts, setCustomFonts] = useState([]);
  const [isColorPickerVisible, setIsColorPickerVisible] = useState(false);
    const contentRef = useRef(null);
    const fileInputRef = useRef(null);
  
    useEffect(() => {
      function handleClickOutside(event) {
        if (contentRef.current && !contentRef.current.contains(event.target)) {
          setIsColorPickerVisible(false); // Hide content if clicked outside
        }
      }
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  const handleFontChange = (e) => {
    const newFont = e.target.value;
    setFontSettings((prev) => ({
      ...prev,
      family: newFont,
    }));
  };

  const handleFontSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    setFontSettings((prev) => ({
      ...prev,
      size: newSize,
    }));
  };


  // Handle font file upload
  const handleFontUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fontName =  file.name.replace(/\.[^/.]+$/, ""); // Remove file extension
    if (!fontName) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const fontData = e.target.result;
      const font = new FontFace(fontName, `url(${fontData})`);
      
      font.load().then(loadedFont => {
        document.fonts.add(loadedFont);
        setCustomFonts(prev => [...prev, { name: fontName, value: fontName }]);
        setFontSettings(prev => ({ ...prev, family: fontName }));
        setFontSettings((prev) => ({
          ...prev, customFonts: [...prev.customFonts, { name: fontName, src: fontData }]
        }));
      }).catch(error => {
        console.error('Font loading failed:', error);
        alert('Failed to load font. Please check the file format.');
      });
    };
    reader.readAsDataURL(file);
  };

  // Combined fonts list
  const allFonts = [...GOOGLE_FONTS, ...customFonts];

  return (
    <div className="flex justify-around align-center flex-wrap p-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="space-y-2 flex justify-center items-center flex-col">
         <div className="flex items-center gap-2">
          <label className="block text-sm font-medium text-gray-700">
            Font Family
          </label>
          <button
            onClick={() => fileInputRef.current.click()}
            className="text-xs font-semibold text-primary hover:text-primary-dark"
            title="Upload custom font"
          >
            [Upload own font]
          </button>
        </div>
        <select
          value={fontSettings.family}
          onChange={handleFontChange}
          className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-sm"
          style={{ fontFamily: fontSettings.family }}
        >
          {allFonts.map((font) => (
            <option
              key={font.value}
              value={font.value}
              style={{ fontFamily: font.value }}
            >
              {font.name} {customFonts.some(f => f.value === font.value) ? '(Custom)' : ''}
            </option>
          ))}
        </select>
        <input
          type="file"
          ref={fileInputRef}
          accept=".ttf,.otf,.woff,.woff2"
          onChange={handleFontUpload}
          className="hidden"
        />
      </div>

      <div className="space-y-2 flex justify-center items-center flex-col">
        <label className="block text-sm font-medium text-gray-700">
          Font Size ({fontSettings.size}px)
        </label>
        <select
          value={fontSettings.size}
          onChange={handleFontSizeChange}
          className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-sm"
        >
          {[12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 48, 56, 64, 72].map(
            (size) => (
              <option key={size} value={size}>
                {size}px
              </option>
            )
          )}
        </select>
      </div>

      <div className="space-y-2 flex justify-center items-center flex-col">
        <label className="block text-sm font-medium text-gray-700">
          Text Color
        </label>
        <div className="flex items-center gap-2">

          <div ref={contentRef} className="relative">
            <div  onClick={() => setIsColorPickerVisible(!isColorPickerVisible)} className="flex items-center gap-2">
          <button  className="w-8 h-8 rounded-md border border-gray-300" style={{ backgroundColor: fontSettings.color }}/>
          <input type="text" value={fontSettings.color} onChange={(e) => setFontSettings((prev) => ({ ...prev, color: e.target.value }))} maxlength="7" className="text-sm w-20" />
          </div>
{ isColorPickerVisible && (
            // Center the color picker below the button
            <div  className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2 z-10">
              <HexColorPicker
                color={fontSettings.color}
                onChange={(color) =>
                  setFontSettings((prev) => ({
                    ...prev,
                    color: color,
                  }))
                }
              />
            </div>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;
